const initialState = {
  sidebarUnfoldable: true,
	sidebarShow: true,
}

export default function coreuiReducer(state = initialState, { type, ...rest }) {
  switch (type) {
    case 'set':
      return { ...state, ...rest }
    default:
      return state
  }
}
